import { Component, inject } from '@angular/core';
import { IonIcon } from '@ionic/angular';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import {
  NtyCmButtonComponent,
  NtyCmTieredModalProps,
  NtyCmTieredPageComponent,
} from '@ninety/mobile/platform/components';
import { LanguageSelectors } from '@ninety/mobile/platform/state';

@Component({
  selector: 'nty-discussion-cm-tiered',
  imports: [IonIcon, LetDirective, NtyCmButtonComponent, NtyCmTieredPageComponent],
  template: `
    <nty-cm-tiered-page *ngrxLet="vm$ as vm">
      <ng-container nty-cm-headline>{{ vm.ntyCmHeadline }}</ng-container>
      <ng-container nty-cm-description>{{ vm.ntyCmDescription }}</ng-container>
      <nty-cm-button>
        <ion-icon [src]="vm.ntyCmButtonIconSrc" />
        {{ vm.ntyCmButtonText }}
      </nty-cm-button>
    </nty-cm-tiered-page>
  `,
  styles: ``,
})
export class DiscussionCmTieredComponent {
  private readonly store = inject(Store);

  private readonly language$ = this.store.select(LanguageSelectors.discussionLanguage);

  public readonly vm$: Observable<NtyCmTieredModalProps> = this.language$.pipe(
    map(language => ({
      ntyCmHeadline: `${language.items} are not available on your current plan.`,
      ntyCmDescription:
        'Upgrade your plan to access enhanced functionality to help you get aligned, get accountable, and grow your business.',
      ntyCmButtonIconSrc: 'assets/icons/lightning--fill.svg',
      ntyCmButtonText: 'Explore plans',
    }))
  );
}
